export default [
  {
    name: 'ChannelsList',
    path: 'settings/channels',
    component: () => import('pages/settings/channels/ChannelsList.vue')
  },
  {
    name: 'ChannelsCreate',
    path: 'settings/channels/new',
    component: () => import('pages/settings/channels/ChannelsForm.vue')
  },
  {
    name: 'ChannelsEdit',
    path: 'settings/channels/:id/edit',
    component: () => import('pages/settings/channels/ChannelsForm.vue')
  }
]
